export default __webpack_public_path__ + "static/media/156.a31fd0bd.jpg";